import mutations from './mutations'
import getters from './getters'
import actions from './actions'
export default {
  namespaced: true,
  state: {
    lineRichMenu: [],
    presetMenu: [],
    richmenuTemplate: [],
    uploadSelectType: null,
    setTypeEditNew: 'new',
    imageSelect: null,
    idTemplate: null,
    packageRichmenu: null,
    scale: null,
    templateSelect: {},
    groupId: null,
    clickTrial: false
  },
  mutations,
  getters,
  actions
}
